// MOTOR DE RENDER config-driven. No sabe nada de "Price Index": solo recorre
// el `layout` de la config, resuelve cada bloque contra el registry y le pasa los
// datos del backend. Cambiar el dashboard = cambiar la config, no este archivo.
import React from 'react';
import { resolveWidget } from './registry';

export default function VisualRenderer({ config, data }) {
  const theme = config.theme || {};
  return (
    <div className="vz-grid">
      {config.layout.map((block, i) => {
        const Widget = resolveWidget(block.type);
        // key estable por widget (no índice): evita remontar/reinicializar el
        // canvas de ECharts cuando se reordena el layout.
        const key = block._widgetId ?? i;
        if (!Widget) {
          return (
            <div key={key} className="vz-cell" style={{ gridColumn: `span ${block.span || 12}` }}>
              <div className="vz-card vz-empty">Widget desconocido: {block.type}</div>
            </div>
          );
        }
        return (
          <div key={key} className="vz-cell" style={{ gridColumn: `span ${block.span || 12}` }}>
            <Widget block={block} data={data} theme={theme} />
          </div>
        );
      })}
    </div>
  );
}
